






















































import { Component, Watch, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'DepositOverdraftSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    hardLimitWasEmpty: boolean = this.productVM.depositOverdraftSettings.hardLimit.amount === "0.00";
    hardLimitOverride: boolean = !this.hardLimitWasEmpty && (this.productVM.depositOverdraftSettings.softLimit.amount !== this.productVM.depositOverdraftSettings.hardLimit.amount);

    @Watch('productVM.depositOverdraftSettings.softLimit.amount')
    async onRequestSoftLimitChanged(val: string) {
        // If the hard limit was empty or the hard limit override is off then soft/hard limit should match
        if (this.hardLimitWasEmpty || !this.hardLimitOverride) {
            this.productVM.depositOverdraftSettings.hardLimit.amount = val;
        }
    }

    @Watch('hardLimitOverride')
    async onHardLimitOverrideChanged(val: boolean) {
        // When the override switch is off, reset the hard limit to match the soft limit
        if (!val) {
            this.productVM.depositOverdraftSettings.hardLimit.amount = this.productVM.depositOverdraftSettings.softLimit.amount;
        }
    }

    get productVM() {
        if (this.isCreate) {
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

}
